exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".change-record{margin-bottom:10px;overflow:hidden}.change-record-info{background:#f2dede;padding:10px;color:#a94442;z-index:1}.change-record-date{margin-right:5px}.change-record-action-group{color:#bdbdbd;font-size:18px}.change-record-action-group i{margin-right:5px;cursor:pointer}.change-record-action-group i:last-child{margin-right:0}.change-record-detail{display:none;padding:10px}.change-record-detail.open{display:block}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/containers/App/screens/Foundation/screens/MyData/components/ChangeRecord/style.css
 ** module id = 1407
 ** module chunks = 4 5 6
 **/